import { useStore } from "@store/index"

export const useTopicsCollection = (avatarId: string) => {
  const { expertInsightsStore } = useStore()
  return expertInsightsStore.topicsStore.getCollection(avatarId)
}

export default useTopicsCollection
